import React, { useEffect, useState } from "react";
import { Nav, Button } from "react-bootstrap";
import { EntityList } from "./EntityList";
import { UserProfile } from "./UserProfile";
import { deleteAllCookies } from "../../utility/cookieProvider";
import { httpPost } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import { AddWidgetIcon, MenuIcon } from "../Icons/icons.component";
import AddTopic from "../Topics/AddTopic.jsx";
import ConceptLogo from "../../assets/images/conceptbiu-logo.png";
import { Configuration } from "./Configuration";
import { getData } from "../../actions/entity-action";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Shared/Loader";
import ReactGA from "react-ga4";
import { getCookie } from "../../utility/cookieProvider.js";
import { COOKIE } from "../../constants/app-constant.js";
import {GACODE} from "../../constants/app-constant";

const [profile, entities, configuration] = [1, 2, 3];

export default function Profile() {
  ReactGA.initialize(GACODE);

  const [selectedTab, setSelectedTab] = useState(1);
  const [showAddTopic, setShowAddTopic] = useState(false);
  const [editData, setEditData] = useState(null);
  const [isSocial, setIsSocial] = useState(true);
  const dispatch = useDispatch();
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      dispatch(getData(selectedClient.id));
    }
  }, [selectedClient]);
  const IsSocialFlag =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.configuration
    ) || {};
  const { isLoading } = IsSocialFlag;
  const { metadata } = IsSocialFlag.configuration;

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.set({ userId: selectedClient.id+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClient.id+".0."+concept_uid });
  }    

  let locationHrefNew = window.location.href;
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.event({
      category: "Profile",
      action: 'Profile Tab - '+selectedClient.id+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    });
  }

  const logoutMe = (e) => {
    e.preventDefault();
    httpPost(`${unifiedEnvConfig.LOGOUT_URL}`).finally(() => {
      deleteAllCookies();
      window.location.href = "/";
    });
  };

  useEffect(() => {
    if (metadata) {
      const { is_social_flag } = metadata.services[0];
      setIsSocial(is_social_flag);
    }
  }, [IsSocialFlag]);
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="mainContainer profileContainer">
          <div className="dashboardHeader dashboardHeaderWithTabs">
            <div className="dashboardHeaderTop d-flex">
              <div className="dashboardMobileMenu">
                <button className="btn menuBtn" id="menuBtn">
                  <MenuIcon />
                </button>
                <img src={ConceptLogo} width="32" height="32" />
              </div>
              <div className="dhLeft d-flex">
                <div className="dhLeftWrap d-flex align-items-center">
                  <h1>Profile</h1>
                </div>
              </div>
              <div className="dhRight">
                {selectedTab == entities && !showAddTopic && (
                  <button
                    className="btn btnBlue addTopicBtn"
                    variant="danger"
                    onClick={() => setShowAddTopic(true)}
                  >
                    <AddWidgetIcon /> <span>Add Topic</span>
                  </button>
                )}
                <Button className="btn logoutBtn" onClick={logoutMe}>
                  Logout
                </Button>
              </div>
            </div>
            <div className="mobTopHeading">
              <h1>Profile</h1>
            </div>
            <div className="dashboardTopTabs">
              <div className="dttLeft">
                <Nav variant="tabs" defaultActiveKey="userDetails">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="userDetails"
                      onClick={() => {
                        setShowAddTopic(false);
                        setSelectedTab(profile);
                      }}
                    >
                      Personal Details
                    </Nav.Link>
                  </Nav.Item>
                  {metadata && isSocial && (
                    <Nav.Item>
                      <Nav.Link
                        eventKey="entities"
                        onClick={() => {
                          setShowAddTopic(false);
                          setSelectedTab(entities);
                        }}
                      >
                        Entities
                      </Nav.Link>
                    </Nav.Item>
                  )}

                  <Nav.Item>
                    <Nav.Link
                      eventKey="configuration"
                      onClick={() => {
                        setShowAddTopic(false);
                        setSelectedTab(configuration);
                      }}
                    >
                      Configuration
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              <div className="dttRight">
                {selectedTab == entities && !showAddTopic && (
                  <button
                    className="btn btnBlue addTopicBtn"
                    variant="danger"
                    onClick={() => setShowAddTopic(true)}
                  >
                    <AddWidgetIcon /> <span>Add Topic</span>
                  </button>
                )}
                <Button className="btn logoutBtn" onClick={logoutMe}>
                  Logout
                </Button>
              </div>
            </div>
          </div>

          <div className="profileMiddleSection">
            {showAddTopic ? (
              <AddTopic
                setShowAddTopic={setShowAddTopic}
                setEditData={setEditData}
                data={editData}
                isEdit={editData}
              />
            ) : (
              <>
                {selectedTab === 1 && <UserProfile />}
                {selectedTab === 2 && (
                  <EntityList
                    setEditData={setEditData}
                    setShowAddTopic={setShowAddTopic}
                  />
                )}
                {selectedTab === 3 && <Configuration />}
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
